<template>
  <div class="editor-container">
    <h3>
      Editează conținutul pentru:
      <strong style="color: #facc15">{{ service }}</strong>
    </h3>

    <div class="editor-buttons">
      <button @click="loadContent">🔄 Reîncarcă</button>
      <button class="save" @click="saveContent">💾 Salvează</button>
      <span v-if="msg" class="msg">{{ msg }}</span>
    </div>

    <textarea
      v-model="text"
      class="editor-textarea"
      spellcheck="false"
      placeholder="Introdu textul pentru această secțiune..."
    ></textarea>

    <p class="hint">
      Editezi JSON-ul care alimentează pagina
      <strong>{{ service }}</strong
      >.<br />
      Structura fișierului se află în:
      <code>/public/content/{{ service }}.json</code>.
    </p>
  </div>
</template>

<script>
export default {
  name: "AdminContentEditor",
  props: {
    service: { type: String, required: true },
  },
  data() {
    return {
      text: "",
      msg: "",
    };
  },
  watch: {
    service() {
      this.loadContent();
    },
  },
  methods: {
    // 🔹 Încarcă fișierul JSON din folderul public/content
    async loadContent() {
      this.msg = "⏳ Se încarcă...";
      try {
        const res = await fetch(`/content/${this.service}.json`);
        if (!res.ok)
          throw new Error("Fișierul nu există sau nu poate fi citit.");
        const data = await res.json();
        this.text = JSON.stringify(data, null, 2);
        this.msg = "✅ Încărcat";
      } catch (err) {
        console.error(err);
        this.text = "";
        this.msg = "❌ Nu s-a putut încărca fișierul";
      } finally {
        setTimeout(() => (this.msg = ""), 2000);
      }
    },

    // 🔹 Trimite conținutul modificat către backend (server.js)
    async saveContent() {
      try {
        const parsed = JSON.parse(this.text);

        const res = await fetch(`/api/content/${this.service}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("adminToken"),
          },
          body: JSON.stringify(parsed),
        });

        const data = await res.json();
        if (!res.ok || !data.success)
          throw new Error(data.message || "Eroare la salvare.");
        this.msg = "💾 Salvat cu succes!";
      } catch (err) {
        console.error(err);
        this.msg = "⚠️ JSON invalid sau eroare la salvare.";
      } finally {
        setTimeout(() => (this.msg = ""), 2500);
      }
    },
  },
  mounted() {
    this.loadContent();
  },
};
</script>

<style scoped>
.editor-container {
  background: #111;
  border: 1px solid #facc15;
  padding: 1.5rem;
  border-radius: 10px;
  margin-top: 2rem;
  color: #fff;
  box-shadow: 0 0 15px rgba(218, 165, 32, 0.2);
}

.editor-container h3 {
  color: #facc15;
  margin-bottom: 1rem;
  font-weight: 700;
}

.editor-buttons {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
  flex-wrap: wrap;
}

.editor-buttons button {
  background: #1f1f1f;
  border: 1px solid #333;
  color: #eee;
  border-radius: 6px;
  padding: 0.5rem 1rem;
  cursor: pointer;
  font-weight: 600;
  transition: 0.2s;
}

.editor-buttons .save {
  background: #facc15;
  color: #000;
  border-color: #facc15;
}

.editor-buttons button:hover {
  opacity: 0.8;
}

.msg {
  color: #facc15;
  font-size: 0.9rem;
}

.editor-textarea {
  width: 100%;
  min-height: 300px;
  background: #000;
  color: #facc15;
  border: 1px solid #444;
  border-radius: 8px;
  padding: 1rem;
  font-family: monospace;
  font-size: 0.95rem;
  resize: vertical;
  margin-bottom: 0.75rem;
  box-sizing: border-box;
}

.hint {
  color: #aaa;
  font-size: 0.9rem;
  margin-top: 0.5rem;
  text-align: left;
  line-height: 1.4;
}

@media (max-width: 900px) {
  .editor-container {
    margin: 1rem 0.5rem;
    padding: 1rem;
  }
  .editor-textarea {
    min-height: 250px;
  }
}
</style>
